// Created from https://github.com/recurly/pay-with-amazon/blob/main/index.js

import React, { useCallback } from 'react'
import { useDevice } from 'device'
import { type ModalComponentProps, standaloneModal } from 'modals'

import { Text } from 'components/dataDisplay'
import { ModalButtons, PlainModal } from 'components/feedback'

import useAmazonWidgetsModal, { type Error } from './util/useAmazonWidgetsModal'


type AmazonWidgetsModalProps = {
  accessToken: string
  sellerId: string
  onClose: () => void
  onError: (error: Error) => void
  onSubmit: (token: { id: string }) => void
  withAddressBook?: boolean
}

const AmazonWidgetsModal: React.FC<AmazonWidgetsModalProps & ModalComponentProps> = (props) => {
  const { accessToken, sellerId, closeModal, onError, onSubmit } = props

  const { isMobile } = useDevice()

  const { buttonTitle, token, error, withAddressBook, isButtonDisabled, isFetching } = useAmazonWidgetsModal({
    accessToken,
    sellerId,
    onError,
  })

  const handleSubmit = useCallback(() => {
    if (token) {
      closeModal()
      onSubmit(token)
    }
  }, [ token, onSubmit, closeModal ])

  return (
    <PlainModal
      className="desktop:!w-[890rem]"
      overlayClassName="!z-above-global-loader"
      overlayClosable={false}
      data-testid="amazonWidgetsModal"
      closeModal={closeModal}
    >
      <div className="mt-32">
        <div className={`grid gap-8 ${isMobile ? 'grid-cols-1' : 'grid-cols-2'}`}>
          {
            withAddressBook ? (
              <>
                <div id="amazon-address-book" />
                <div id="amazon-wallet" />
                {!isMobile && <div />}
                <div id="amazon-consent" />
              </>
            ) : (
              <>
                <div id="amazon-wallet" />
                <div id="amazon-consent" />
              </>
            )
          }
        </div>
      </div>
      {
        Boolean(error) && (
          <Text
            className="mt-16"
            message={error}
            html
            style="p2"
            color="red"
          />
        )
      }
      <ModalButtons
        primary={{
          title: buttonTitle,
          loading: isFetching,
          disabled: isButtonDisabled,
          onClick: handleSubmit,
        }}
      />
    </PlainModal>
  )
}

declare global {
  interface ModalsRegistry extends ExtendModalsRegistry<{ amazonWidgetsModal: typeof AmazonWidgetsModal }> {}
}

export default standaloneModal('amazonWidgetsModal', AmazonWidgetsModal)
